import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=5f765892&"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/components/_NotificationsMenu.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
